module.exports = __webpack_public_path__ + "img/pistol.revolver.8effa198.png";